import type { AuthState, GetterClass } from '../../../models'

export class TokenGetter implements GetterClass {
  static execute(this: void, state: AuthState): string {
    return state.token
  }
}
